/* unplugin-vue-components disabled */import { render } from "./md-content.vue?vue&type=template&id=070293a2"
import script from "./md-content.vue?vue&type=script&lang=js"
export * from "./md-content.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/md-content/md-content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "070293a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('070293a2', __exports__)) {
    api.reload('070293a2', __exports__)
  }
  
  module.hot.accept("./md-content.vue?vue&type=template&id=070293a2", () => {
    api.rerender('070293a2', render)
  })

}


export default __exports__